module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td class="'+
((__t=( uuid ))==null?'':__t)+
'">'+
((__t=( type ))==null?'':__t)+
'</td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'" hidden>'+
((__t=( npi ))==null?'':__t)+
'</td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'">'+
((__t=( link() ))==null?'':__t)+
'</td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'">'+
((__t=( relation ))==null?'':__t)+
'</td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'">'+
((__t=( contactor ))==null?'':__t)+
'</td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'">'+
((__t=( comment ))==null?'':__t)+
'</td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'" hidden>'+
((__t=( entityId ))==null?'':__t)+
'</td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'" hidden>'+
((__t=( groupUuid ))==null?'':__t)+
'</td>\r\n';
 if (canEdit) { 
__p+='\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'"><span class="glyphicon glyphicon-edit clickable" id="representative-edit" rel-id="'+
((__t=( uuid ))==null?'':__t)+
'"/></td>\r\n<td class="'+
((__t=( uuid ))==null?'':__t)+
'"><span class="glyphicon glyphicon-remove clickable" id="representative-delete" rel-id="'+
((__t=( uuid ))==null?'':__t)+
'"/></td>\r\n';
 } 
__p+='';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/contacts/representative-row.html
// module id = 262
// module chunks = 0